export default __webpack_public_path__ + "static/media/paymentsImages.d09d7cbb.svg";